import React, { useContext } from 'react'
import FormalityStepForm from './FormalityStepForm'
import { FormalityActionsWrapper } from './styles'
import { AbilityContext } from 'contexts/abilityContext'

const FormalityActions = () => {
  const ability: any = useContext(AbilityContext)
  const formalistOnly = ability.can('update', 'LegalFormality')

  if (!formalistOnly) return <></>

  return (
    <FormalityActionsWrapper>
      <FormalityStepForm />
    </FormalityActionsWrapper>
  )
}

export default FormalityActions
